import React, { useState } from 'react';
import { RiCheckboxCircleFill, RiCloseFill } from 'react-icons/ri';

import Swal from 'sweetalert2';

export function SuccessAlert({ message, onClose }) {
  Swal.fire({
    title: 'SUCCESS!',
    html: message,
    icon: 'success',
    confirmButtonText: 'OK',
    showConfirmButton: true,
    confirmButtonColor: '#2aa2db',
    preConfirm: onClose(),
  });
  return null;
  // <div>
  //   <div>
  //     <div className="overlay">
  //       <div
  //         className="popupWarning   align-items-center"
  //         style={{
  //           backgroundColor: 'white',
  //           // borderWidth: 2,
  //           // borderColor: '#c5e1bd',
  //           borderRadius: 15,
  //           border: 'none',
  //         }}
  //       >
  //         <div className="">
  //           <div className="alert_modal-header d-flex align-items-center input_item justify-content-center">
  //             <RiCheckboxCircleFill size={80} fill={colorTheme.slideTag} />
  //           </div>
  //           <div style={{ paddingTop: 10 }}>
  //             <div
  //               className="pb-0 mb-0 d-flex justify-content-center"
  //               style={{
  //                 color: '#000',
  //                 fontSize: 20,
  //                 fontWeight: '900',
  //               }}
  //             >
  //               {'SUCCESS!'}
  //             </div>
  //             <div
  //               style={{ lineHeight: 1, color: '#809278' }}
  //               className="d-flex justify-content-center "
  //             >
  //               {message}
  //             </div>
  //             <div className="d-flex justify-content-end mt-3">
  //               <button onClick={onClose} className="btn_submit_alert">
  //                 {'OK'}
  //               </button>
  //             </div>
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   </div>
  // </div>
}
